// extracted by mini-css-extract-plugin
export default {"wrapper":"NavBarComponent_wrapper__h8XsA","hamburgerButton":"NavBarComponent_hamburgerButton__EBrmO","title":"NavBarComponent_title__FgH6f"};